import React, { useState, useEffect } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableRow, Paper,
    TableHead, TablePagination, TextField, Dialog,
    DialogActions, DialogContent, Box, DialogContentText, Tooltip, DialogTitle, Button, Typography, Link
} from '@mui/material';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import AddPreguntaEncuesta from './AddPreguntaEncuesta';
import { useAccesos } from '../contexts/AccesosContext';



function GestionPreguntaEncuesta({idEncuesta = null, encuestas: encuestasProp = null, modoLectura = false}) {

    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [preguntas, setPreguntas] = useState([]);
    const [editPregunta, setEditPregunta] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [preguntaToDelete, setPreguntaToDelete] = useState(null);
    const { user } = useUser();      
    const { tienePermiso } = useAccesos();
    // Estado con tareas simuladas
    

    const fetchPreguntas = async () => {
                    try {
                        const response = await fetch(`${server}/CrmPreguntaEncuestums/poridEncuesta/${idEncuesta}`);
                        const data = await response.json();
                        setPreguntas(data.$values);
                    } catch (error) {
                        console.error('Error al cargar las Preguntas:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al cargar las Preguntas: ' + error,
                        });
                    }
                };

            useEffect(() => {
                const fetchPreguntas = async () => {
                    try {
                        let response;
                        if(idEncuesta) {
                            response = await fetch(`${server}/CrmPreguntaEncuestums/poridEncuesta/${idEncuesta}`);
                        } else {
                            response = await fetch(`${server}/CrmPreguntaEncuestums`);
                        }

                        const data = await response.json();
                        setPreguntas(data.$values || []);
                    } catch (error) {
                        console.error('Error al cargar las preguntas', error);
                        Swal.fire({
                            icon:'error',
                            title:'Error',
                            text: 'Error al cargar las preguntas: '+ error,
                        });
                    }

                };

                    fetchPreguntas();
                
            }, [idEncuesta, encuestasProp]);

            if (!idEncuesta) {
                    return (
                    <Typography variant="body1" color="textSecondary">
                        Selecciona una encuesta para ver sus preguntas.
                    </Typography>
                );
            }
        
            const handleNewPregunta = () => {
                if(idEncuesta) {
                    fetch(`${server}/CrmPreguntaEncuestums/poridEncuesta/${idEncuesta}`)
                    .then(res => res.json())
                    .then(data => setPreguntas(data.$values || []))
                    .catch(console.error);
                }else{
                    fetch(`${server}/CrmPreguntaEncuestums`)
                    .then(res => res.json())
                    .then(data => setPreguntas(data.$values || []))
                    .catch(console.error);
                }
                
                setEditPregunta(null);
            };
        
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (pregunta) => {
                setPreguntaToDelete(pregunta);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setPreguntaToDelete(null);
            };
        
            const handleDeletePregunta = async () => {
                if (preguntaToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';

                        const response = await fetch(`${server}/CrmPreguntaEncuestums/${preguntaToDelete.idPregunta}/${username}`,
                             {
                            method: 'DELETE'
                        });
                        if (response.ok) {
                            handleCloseDialog();
                            fetchPreguntas(); // Recargar la lista de campanias
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Pregunta eliminada con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar la pregunta:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar la pregunta: ' + error,
                        });            }
                }
            };
        
            const filteredPregunta = preguntas.filter(pregunta => pregunta.textoPregunta?.toLowerCase().includes(searchQuery.toLowerCase()));
    
    const handleCancelarEdicion = () => {
        setEditPregunta(null);
    };

    return (
        <>
            <div className="x_content">
                <br />
                
                < AddPreguntaEncuesta handleNewPregunta={handleNewPregunta} editPregunta={editPregunta} idEncuesta={idEncuesta} cancelarEdicion={handleCancelarEdicion} modoLectura={modoLectura}/>
                <div className="ln_solid" />
                <h2>Preguntas Existentes</h2>

                <TextField
                    fullWidth
                    variant="outlined"
                    label="Buscar Pregunta"
                    placeholder="Buscar..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{ marginBottom: '20px' }}
                />

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="right"><strong>Acciones</strong></TableCell>
                                <TableCell><strong>Título</strong></TableCell>
                                <TableCell><strong>Tipo Pregunta</strong></TableCell>
                                <TableCell><strong>Obligatoria</strong></TableCell>
                                <TableCell><strong>Orden</strong></TableCell>
                                <TableCell><strong>Categoria</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredPregunta.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((pregunta) => (
                            <TableRow key={pregunta.idPregunta}>
                                <TableCell align="right">
                                    <Button onClick={() => setEditPregunta(pregunta)} color="primary" disabled={!tienePermiso('Editar Pregunta Encuesta')}>
                                        Editar
                                    </Button>
                                    {modoLectura ? (
                                    <Tooltip title="No se puede eliminar: la pregunta ya tiene respuestas">
                                    <span>
                                    <Button onClick={() => handleOpenDialog(pregunta)} color="secondary" disabled>
                                        Eliminar
                                    </Button>
                                    </span>
                                    </Tooltip>
                                    ) : (
                                        <Button
                                            onClick={() => handleOpenDialog(pregunta)}
                                            color="secondary"
                                            disabled={!tienePermiso('Eliminar Pregunta Encuesta')}
                                            >
                                            Eliminar
                                        </Button>
                                    )}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {pregunta.textoPregunta}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {pregunta.tipoPregunta}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {pregunta.esObligatoria ? 'Sí' : 'No'}
                                </TableCell>
                                {/* <TableCell component="th" scope="row">
                                    {objetivo.IdCampania}
                                </TableCell> */}
                                <TableCell component="th" scope="row">
                                    {pregunta.ordenPregunta}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {pregunta.categoria}
                                </TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={preguntas.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
                    <Dialog open={openDialog}
                        onClose={handleCloseDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                        <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            ¿Estás seguro de que quieres eliminar esta pregunta?
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                        <Button onClick={handleDeletePregunta} color="primary" autoFocus>Eliminar</Button>
                        </DialogActions>
                    </Dialog>

                 
            </div>
        </>
    );
}

export default GestionPreguntaEncuesta;